export default __webpack_public_path__ + "static/media/reporting-office-glyph-16px.cd3779c7.svg";